export default __webpack_public_path__ + "assets/southsudan-flag.png";